import { useMsal } from '@azure/msal-react';
import {
  Tab,
  Tabs,
  TabList,
  TabPanel,
  TabPanels,
  Flex,
} from '@chakra-ui/react';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import InventoryPage from '../Inventory/InventoryPage';
import TrackingPg from '../Tracking/TrackingPg';
import FailedInventoryPage from '../FailedInventory/FailedInventoryPage';
import HIMInventoryPage from '../HIMInventory/HIMInventoryPage';
interface UserData {
  UserRole: string;
  // Add other properties as needed
}

export default function InventoryNav({ setTabIndex }: { setTabIndex: any }) {
  const userdetails = JSON.parse(localStorage.getItem('userdetails') || '{}');
  const components = userdetails[0]?.components || []; 

  const userRoles: string[] =
    process.env.REACT_APP_USER_ROLES?.split(',') || [];
  const superAdmin: string[] =
    process.env.REACT_APP_SUPER_ADMIN?.split(',') || [];


    const tabs = [
      { name: "Inventory", component: "InventoryPage", content: <InventoryPage /> },
      { name: "Tracking", component: "TrackingPg", content: <TrackingPg /> },
      { name: "Failed Inventory", component: "FailedInventoryPage", content: <FailedInventoryPage /> },
      { name: "HIM Inventory", component: "HIMInventory", content: <HIMInventoryPage /> },
    ];

    const accessibleTabs = tabs.filter((tab) =>
      components.includes(tab.component)
    );
  

  return (
    <>
      <Flex onClick={setTabIndex(0)}>
        <Tabs mt={2} onClick={setTabIndex(0)}  width="100%">
          <TabList>
            {accessibleTabs.map((tab, index) => (
              <Tab key={index}>{tab.name}</Tab>
            ))}
          </TabList>
          <TabPanels mt={4}>
            {accessibleTabs.map((tab, index) => (
              <TabPanel key={index} p={0}>
                {tab.content}
              </TabPanel>
            ))}
          </TabPanels>
        </Tabs>
      </Flex>
    </>
  );
}
